$(function() {

    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
        $('html').addClass('_safari');
    };

    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    function sendGa(category, action, label) {
        ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label
        });
    }

    svg4everybody();

    $( window ).on( "orientationchange", function( event ) {
        console.log( "This device is in " + event.orientation + " mode!" );

        if(($(window).width() < 961) && (event.orientation === 'landscape')) {
            $('body').addClass('turn');
        } else {
            $('body').removeClass('turn');
        }
    });

    function createFullpage() {
        $('#fullpage').fullpage({
            menu: '#menu',
            fitToSection: true,
            keyboardScrolling: true,
            animateAnchor: true,
            verticalCentered: false,
            scrollOverflow: true,
            fixedElements: '#navigation, .page-header, #menu',
            // scrollOverflowOptions: {
            //     click:false,
            //     tap: true
            // },
            resize: true,
            licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
            // normalScrollElements: '.js-modal',
            onLeave: function(index, nextIndex, direction) {
                if (direction == 'down' && index.index == 0) {
                    $('#menu').addClass('_inner');
                };
                if (direction == 'up' && index.index == 1) {
                    $('#menu').removeClass('_inner');
                }
                if (nextIndex !== 1) {
                    var label = index.anchor;
                    sendGa('letters', 'show', label)
                }
            }
        });
    }

    createFullpage();

    $('.menu__item').hover(
        function() {
            $(this).find('.gift').addClass('show');
        },

        function() {
            $(this).find('.gift').removeClass('show');
        }
    )

    // if ($('.scrollable').length) {
    //     $('.scrollable').mCustomScrollbar();
    // };

    $('.js-nav-toggler').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.menu').removeClass('opened');
            $('body').removeClass('overflow');
        } else {
            $(this).addClass('active');
            $('.menu').addClass('opened');
            $('body').addClass('overflow');
        }
        
    });

    if ($(window).width() < 1025) {
        $('.menu__item').on('click', function() {
            $('.menu__item').removeClass('active');
            $(this).addClass('active');
            $('.js-nav-toggler').removeClass('active');
            $('.menu').removeClass('opened');
            $('body').removeClass('overflow');
        })
    }

    var menuScroll = function() {
        if ($(window).width < 769) {
            $('#menu a').on('click', function(e) {
                var $target = $($(this).attr('href')),
                    targetOffset = $target.offset().top;

                if ($target.length) {
                    e.preventDefault();

                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 600);
                }
            })
        };
        if ($('.js-scroll-link').length) {
            var scrollLink = $('.js-scroll-link');
            scrollLink.on('click', function(e) {
                var $target = $($(this).attr('href')),
                    targetOffset = $target.offset().top;

                if ($target.length) {
                    e.preventDefault();

                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 600);
                }
            })
        }
    };

    menuScroll();

    $('.js-close-letter').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.js-letter').removeClass('_opened');
    });

    $('.js-open-letter').on('click', function() {
        $(this).closest('.js-letter').addClass('_opened');
    })

    $(window).on('resize', function() {
        createFullpage();
        menuScroll();
    });

    $('.logo-lenta').on('click', function() {
        sendGa('main', 'click', 'lenta');
    });

    $('.logo-avito').on('click', function(){
        sendGa('main', 'click', 'avito');
    });

    $('.ya-share2__item_service_twitter').on('click', function () {
        sendGa('main', 'click', 'share tw');
    });

    $('.ya-share2__item_service_facebook').on('click', function () {
        sendGa('main', 'click', 'share fb');
    });

    $('.ya-share2__item_service_vkontakte').on('click', function () {
        sendGa('main', 'click', 'share vk');
    });

    $('.ya-share2__item_service_odnoklassniki').on('click', function () {
        sendGa('main', 'click', 'share ok');
    });

    $('.scroll-link').on('click', function(){
        sendGa('main', 'click', 'arrow');
    });

    $('.navigation-list__link').on('click', function(){
        sendGa('main', 'click', $(this).html());
    });

    $('.item-block__btn').on('click', function(){
        var text = $(this).parents('.item-block__descr').find('.item-block__descr-row:first-child .item-block__text b').html(),
        label = text.replace(/<br>/g," ");

        sendGa('letters', 'click', 'go to avito '+label);
    });
});


